import { render } from "./EmpresaList.vue?vue&type=template&id=56f49666"
import script from "./EmpresaList.vue?vue&type=script&lang=js"
export * from "./EmpresaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__